module.exports = __webpack_public_path__ + "static/special1-dc911a427e3be3d622bdc2ba7b898e57.jpg";